import { render, staticRenderFns } from "./investment.vue?vue&type=template&id=c8e99704&scoped=true"
import script from "./investment.vue?vue&type=script&lang=js"
export * from "./investment.vue?vue&type=script&lang=js"
import style0 from "./investment.vue?vue&type=style&index=0&id=c8e99704&prod&lang=scss&scoped=true"
import style1 from "./investment.vue?vue&type=style&index=1&id=c8e99704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e99704",
  null
  
)

export default component.exports